import { NavClientService } from '@common/navdata';
import { fn, IInfOperation } from '@common/utils';
import { CreateWorkflowModal } from './createworkflow/createworkflow.ctrl';
import UISafe = fn.UISafe;
import { CompatibilityService } from '@services/compatibilityservice';
import { ObservableArray } from '@common/nav';
import { KFWFormSessionQueue } from './editform/formsessionqueue';
import { KWFPreviewService } from './rwfpreview/KWFPreviewService';
import { KWFApplicationService } from './KWFApplication';
import { INavGrid } from '@common/navkendo/navgrid';
import { GetSelectedRowValues } from './KWFUtils';
import { KWFNotificationService } from './KWFNotificationService';

/** Global Access to "Global Actions" */
export class KWFAppActions {
    static $inject = ["CompatibilityService", "$injector", "KWFApplication", "NavClient", "KWFNotificationService"];
    constructor($c: CompatibilityService, private $injector: ng.auto.IInjectorService, private KWFApplication: KWFApplicationService, NavClient: NavClientService, private notificationService: KWFNotificationService) {
        // Enable Edit Global Markups for admins only
        KWFApplication.GetGlobalSettings().then(s => {
            if (s && s.CheckPages && s.CheckPages["FDRW_Workflow_Start"] === false)
                this.MyInvoices.NewWFAction.Hidden = true;
        });

        this.MyInvoices = new MassActions(this.$injector, this.notificationService);
        this.FWF = new MassActions(this.$injector, this.notificationService);

        // Allow "Create Workflow" not only in BWF!
        //this.KWFApplication.GetKWF3Settings().then(s => this.MyInvoices.NewWFAction.Hidden = !s.IsBWFActive)

        // Bestimmung der "Erzeuge neuen Workflow" Aktionen

        //var client = this.KWFApplication.NavClient;
        //UISafe(client.LoadItemsSeperate({
        //    PageName: rwf3pages.FDRW_Workflow_Start.PageName,
        //    Constraints: [],
        //    PageCount: 0
        //}, this.KWFApplication).then(data => {
        //    data.forEach(createModel => {
        //        var createItem = <rwf3.IFDRW_Workflow_Start><any>createModel.Model;
        //        this.MyInvoices.NewWFActions.push({
        //            Caption: createItem.WorkflowStepName,
        //            Execute: () => {
        //                UISafe(createModel.ExecuteMethod(rwf3pages.FDRW_Workflow_Start.Methods.StartAndOpenNewWorkflow(createModel.Key, "")).then((r) => {

        //                    var newItemId = r["Result"];
        //                    this.KWFApplication.OpenRowItem({ ID: newItemId });
        //                }));
        //            }
        //        });
        //    });

        //}));

        function massAccess(guid: string): PromiseLike<{ Curr: string, Count: number }>;
        function massAccess(guid: string, items: string[]): PromiseLike<void>;
        function massAccess(guid: string, items?: string[]): any {
            var storage = dummyLocalStorage; // do not Use LocalStorage (WTF, WI 25577)
            var key = "MassOpen_" + guid;
            if (!items) {
                var result = (<string>storage.getItem(key) || "").split(",");
                return massAccess(guid, result.slice(1)).then(() => { return { Curr: result[0], Count: result.length - 1 }; });
            }
            else {
                if (items.length == 0)
                    storage.removeItem(key);
                else
                    storage.setItem(key, items.join(","));
                return $c.when(undefined);
            }
        }
        /** temp "local" replacement for localStorage if not available */
        var dummyLocalStorage = (function () {
            var data = {};
            return {
                getItem: (key: string) => data[key],
                setItem: (key: string, v: string) => { data[key] = v; },
                removeItem: (key: string) => delete data[key]
            };
        })();
    }

    /** My Invoices Related Actions */
    public MyInvoices: MassActions;

    /** FWF Related Actions */
    public FWF: MassActions;
}


class MassActions {
  static $inject = ["$injector", "KWFNotificationService"];
    constructor(private readonly $injector: ng.auto.IInjectorService, private notificationService: KWFNotificationService) {
        this.MassRoute = {
            Enabled : false,
            Execute :() => this.massRoute()
        };

        this.MassOpen = {
            get Current() {
                return KFWFormSessionQueue.Current; },
            Enabled : false,
            Execute: () => this.massOpen(),
            OpenNext: () => KFWFormSessionQueue.OpenNextMassItem(),
            Clear: () => KFWFormSessionQueue.Cleanup(), // Clear massAccess
        };

        this.NewWFAction = {
            Caption: "Workflow Starten ...",
            Hidden: false,
            Execute: () => CreateWorkflowModal(this.$c)
        }

        this.$c.resolve("Rwf")("RwfBootstrap").OnResolved(r => {
            if(r.RwfSetup.BatchProcessingEnabled === false) {
                this.massRouteEnabled = false;
            }
        });

    }
    private _grid : INavGrid;
    private selection: ObservableArray;
    private massRouteEnabled = true;
    private get $c() { return this.$injector.get("CompatibilityService"); }
    get Grid() {return this._grid; }
    /**  Selected My Invoices unfort. needs access ...*/
    SetInvoiceGrid(grid: INavGrid)  {
        this._grid = grid;
        var selItems = grid && grid.GetSelectedItems(),
            selection = selItems && selItems.GetSelectedItems();

        if (selection !== this.selection) {
            const mySelChange = this._mySelChange.bind(this);
            if (selection)
                selection.unbind("change", mySelChange);
            this.selection = selection;
            if (selection)
                selection.bind("change", mySelChange);
            mySelChange(this);
        }

        return () => this.SetInvoiceGrid(null);
    }
    /** Current Selection Count */
    SelCount: number;
    /** Action to MassRoute Currently Selected MyInvoice Items */
    MassRoute: IInfOperation;
    /** Mass Open Selected Itmes Action */
    MassOpen: IInfOperation & {
        OpenNext: () => boolean | PromiseLike<boolean>;
        Clear: () => PromiseLike<void>;
        readonly Current: KFWFormSessionQueue;
    };
    NewWFAction: IInfOperation & {
        Caption: string;
    };

    /** My Invoices Selection Change Refresh */
  _mySelChange() {
    const selection = this.selection;
    var breakoutActiveSelections = selection.filter(sel => sel["CurrentBreakout"] !== null && sel["CurrentBreakout"] !== undefined && sel["CurrentBreakout"] !== '');

    if (breakoutActiveSelections.length > 0) {
      this.notificationService.AddNotification({
        message: "Die Weiterleitung von Workflows mit aktivem Fachprozess ist in der Einrichtung deaktiviert. (Lfd. nr.  "
          + breakoutActiveSelections[0]["EntryNo"] + ")",
        hint: "Hint",
        messageType: "warning",
        identifier: "KWF.ClientWarning"
      });
    }

    document.addEventListener('blur', () => {
      this.notificationService.RemoveNotifications("KWF.ClientWarning");
    }, true);

    
    // Get all checkboxes
    const checkboxes = document.querySelectorAll('input.navRowCheckbox') as NodeListOf<HTMLInputElement>;

    // Function to remove the notification if a checkbox is unchecked
    const handleCheckboxChange = (checkbox: HTMLInputElement) => {
      if (!checkbox.checked) {
        this.notificationService.RemoveNotifications("KWF.ClientWarning");
      }
    };

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', (event) => {
        const targetedCheckbox = event.target as HTMLInputElement;

        // Check if it's a "master" checkbox by checking for the 'data-rid' attribute
        const isMasterCheckbox = targetedCheckbox.hasAttribute('data-rid');

        if (isMasterCheckbox) {
          // Apply logic for master checkbox if needed
          handleCheckboxChange(targetedCheckbox);
        } else {
          // Apply logic for the child checkboxes if needed
          handleCheckboxChange(targetedCheckbox);
        }
      });
    });


        this.SelCount = (selection && selection.length) || 0;
        this.MassOpen.Enabled = this.SelCount > 0 && breakoutActiveSelections.length == 0;
        this.MassRoute.Enabled = this.massRouteEnabled && this.MassOpen.Enabled;

        if (!this.Grid || !this.Grid["$angular_scope"]) {
            this.$c.tick();
        }
    }

    massRoute() {
        const kgrid = this.Grid;
        const $c = this.$c;
        const $rwf = $c.resolve("Rwf");
        const KWFApplication = $rwf("RwfApplication");
        if(!this.massRouteEnabled) {
            return $c.reject("Die Funktionalität 'Massenweiterleitung' ist in diesem Mandanten deaktiviert!");
        }
         // Preview popup makes no sense to rest on modal dialog, so close it!
         this.HidePreview();

         const selectedItems = GetSelectedRowValues(kgrid);
         // Run action of IDs
         var showWindow = UISafe($rwf("RwfUserInteraction").ModalMassRouteInstances(selectedItems, KWFApplication.LoadedSettings.NavUrl));

         // Show busy indicator during window open process
         if (kgrid) {
             kgrid.wrapper.kendoNavBusyIndicator(showWindow);
         }

         showWindow.then(window => {
             window.close.then(() => {
                 // Remember selected rows to restore after refresh
                 var selection = kgrid && kgrid.GetSelectedItems();

                 const afterRefresh = () => {
                     // Reselection of remaining selected
                     if (selection) {
                         selection.Revalidate();
                     }
                 };
                 // Refresh on dialog close
                 $c.when(KWFApplication.GetInvoiceData(true)).then(invoiceData => {
                     if (invoiceData) {
                         invoiceData.ActRefreshInvoiceData.Refresh().then(afterRefresh, afterRefresh);
                     }
                 });
             });
         });
    }

    massOpen() {
        const kgrid = this.Grid;
        const $c = this.$injector.get("CompatibilityService");
        const NavClient = $c.resolve("NavClient");
        // Preview popup makes no sense to rest on modal dialog, so close it!
        this.HidePreview();

        // Extract Selected Instanceswindow.clo
        var selectedItems = GetSelectedRowValues(kgrid);
        var selInstanceIds = selectedItems.map(item => "" + item.ID);
        if (selInstanceIds.length == 0)
            return this.$c.when(false);


        var queue = KFWFormSessionQueue.Current = new KFWFormSessionQueue(this.$injector, NavClient, $c, selInstanceIds);

        kgrid.element.kendoNavBusyIndicator(true);

        return queue.openNextMassItem().then((s) => {
            if (!s) {
                kgrid.element.kendoNavBusyIndicator(false);
            }
            return s;
        }, err => { kgrid.element.kendoNavBusyIndicator(false); throw err; });
    }

    private HidePreview() {
        (this.$injector.get("KWFPreviewService") as KWFPreviewService).HidePreview();
    }
}

